<template>
  <div v-if="analyticsData" class="grid center between ver-margin-30">
    <analyticsRowBlock
      v-for="(block, index) in dataList"
      :key="block.name + index + Date.now()"
      :blockClass="classBlock(block, index)"
      :blockWidth="block.width"
      :data="block"
      :currency="currency"
    ></analyticsRowBlock>
  </div>
</template>

<script>
import analyticsRowBlock from "@/components/dashboard/analyticsRowBlock.vue";

export default {
  name: "analyticsRow",
  props: ["analyticsData", "type", "currency"],
  data() {
    return {};
  },
  methods: {
    classBlock(block) {
      if (this.type == "general") {
        return block.name == "success" ? "success-orders" : "fail-orders u";
      }
    }
  },
  computed: {
    dataList() {
      let list = this.analyticsData.list;
      let items = list.filter(el => el.total > 0);
      return items.length > 0 ? items : list;
    }
  },
  components: {
    analyticsRowBlock
  }
};
</script>
